import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { qk } from '@/api/keys';
import { toast } from '@/components/ui';
import { onPushMessage, refreshPush } from '@/lib/push';

/**
 * Keeps browser alerts working across loads: re-registers this browser's token while alerts are
 * on (tokens rotate), and when the service worker reports a push while a tab is open, refreshes
 * the alert queries — the list and the rail's unread badge — and says so, since a focused tab
 * gets no notification of its own (`public/push-sw.js`).
 */
export function usePushBootstrap() {
  const qc = useQueryClient();
  useEffect(() => {
    void refreshPush();
    return onPushMessage((m) => {
      void qc.invalidateQueries({ queryKey: qk.alerts.all });
      if (m.body) toast.info(m.body);
    });
  }, [qc]);
}
